module.exports = __webpack_public_path__ + "static/product_scaling-118bd61677fe30ebe1bf47cc72e0ab29.png";